import React, { Component } from 'react';
import { HeaderWrapper, IconButton, Button, LogoImage } from 'components/StyledComponents';

export default props => (
  <HeaderWrapper>
    <LogoImage />
  </HeaderWrapper>
);



// WEBPACK FOOTER //
// ./src/components/Header.js